import { REDUX_CONST } from '../../constants'

export const getJobs = (state = { data: [] }, action) => {
	switch (action.type) {
		case REDUX_CONST.giddyUp.jobConstants.getJobs.request:
			return { loading: true }
		case REDUX_CONST.giddyUp.jobConstants.getJobs.success:
			return { data: action.payload }
		case REDUX_CONST.giddyUp.jobConstants.getJobs.fail:
			return { error: action.payload }
		default:
			return state
	}
}
export const getJobsInfo = (state = { data: [] }, action) => {
	switch (action.type) {
		case REDUX_CONST.giddyUp.jobConstants.getJobsInfo.request:
			return { loading: true }
		case REDUX_CONST.giddyUp.jobConstants.getJobsInfo.success:
			return { data: action.payload }
		case REDUX_CONST.giddyUp.jobConstants.getJobsInfo.fail:
			return { error: action.payload }
		default:
			return state
	}
}
export const getJobValues = (state = { data: [] }, action) => {
	switch (action.type) {
		case REDUX_CONST.giddyUp.jobConstants.getJobValues.request:
			return { loading: true }
		case REDUX_CONST.giddyUp.jobConstants.getJobValues.success:
			return { data: action.payload }
		case REDUX_CONST.giddyUp.jobConstants.getJobValues.fail:
			return { error: action.payload }
		default:
			return state
	}
}
